import { Check } from 'lucide-react';
import { Reveal } from '../Reveal';

const Column = ({ heading, copy, areas, accentDark, accentSoft, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
    <h2 className="text-2xl font-extrabold tracking-tight text-navy-900 sm:text-3xl">{heading}</h2>
    <p className="mt-4 text-base leading-relaxed text-slate-600">{copy}</p>
    <ul className="mt-7 space-y-3.5">
      {areas.map((area) => (
        <li key={area} className="flex items-start gap-3 text-sm font-medium text-navy-800 sm:text-base">
          <span
            className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
            style={{ backgroundColor: accentSoft }}
          >
            <Check className="h-3 w-3" style={{ color: accentDark }} aria-hidden="true" />
          </span>
          {area}
        </li>
      ))}
    </ul>
  </div>
);

export const ServiceWhatWho = ({ data, accent, accentDark, accentSoft, testidPrefix }) => (
  <section aria-label="What we do and who it is for" data-testid={`${testidPrefix}-what-who`} className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <p className="flex items-center justify-center gap-3">
        <span className="font-mono text-xs font-medium tracking-widest" style={{ color: accent }}>01</span>
        <span className="text-xs font-bold uppercase tracking-[0.2em]" style={{ color: accent }}>What we do</span>
      </p>
      <div className="mt-12 grid gap-8 lg:grid-cols-2">
        <Reveal className="h-full">
          <Column
            heading={data.whatHeading}
            copy={data.whatCopy}
            areas={data.whatAreas}
            accentDark={accentDark}
            accentSoft={accentSoft}
            testid={`${testidPrefix}-what-we-do`}
          />
        </Reveal>
        <Reveal delay={0.1} className="h-full">
          <Column
            heading={data.whoHeading}
            copy={data.whoCopy}
            areas={data.whoAreas}
            accentDark={accentDark}
            accentSoft={accentSoft}
            testid={`${testidPrefix}-who-its-for`}
          />
        </Reveal>
      </div>
    </div>
  </section>
);
